import { GlobeAltIcon } from '@heroicons/react/24/outline';
import Fonts from '../../core/fonts';
export default function AppLogo() {
  return (
    <div
      className={`${Fonts.lusitanaRegular} flex flex-row items-center leading-none text-white`}
    >
         <img
            src="/logo.png"
            width={240}
            height={160}
            className="hidden rounded-md md:block"
            alt="NClood Logo"
          />
      {/* <GlobeAltIcon className="h-12 w-12 rotate-[15deg]" />
      <p className="text-[30px] whitespace-nowrap">NClood</p> */}
    </div>
  );
}
